<template>
</template>

<script>
import { balloons } from '../../ts/balloons/index.js';
export default {
    created() {
        balloons();
    }
}
</script>
